import Nullstack from 'nullstack';
export default function IconArrowsShuffle({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-shuffle",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M18 4l3 3l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M18 20l3 -3l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
  }), "   ", Nullstack.element("path", {
    d: "M21 7h-5a4.978 4.978 0 0 0 -2.998 .998m-4.002 8.003a4.984 4.984 0 0 1 -3 .999h-3"
  }), " ");
}